import {
    Box, Button, Icon,
    Paper, Typography, useTheme,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import clsx from 'clsx';
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { EstatisticasService, IDadosTimeVersus } from "../../shered/services/api/estatisticas/EstatisticasService";
import { DataGrid, GridCellParams, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { FranquiaService } from "../../shered/services/api/franquia/FranquiaService";

const lstQtdRodadasFiltro = [
    {
        codigo: 5,
        label: "5"
    },
    {
        codigo: 10,
        label: "10"
    },
    {
        codigo: 15,
        label: "15"
    },
    {
        codigo: 20,
        label: "20"
    },
    {
        codigo: 25,
        label: "25"
    },
    {
        codigo: 30,
        label: "30"
    },
    {
        codigo: 35,
        label: "35"
    },
    {
        codigo: 40,
        label: "40"
    },
    {
        codigo: 45,
        label: "45"
    },
    {
        codigo: 50,
        label: "50"
    }
    ,
    {
        codigo: 100,
        label: "100"
    }
];



export const ListagemDeFranquiaVersus: React.FC = () => {
    const theme = useTheme();
    const { themeName } = useAppThemeContext();

    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [estatisticasRows, setEstatisticasRows] = useState<IDadosTimeVersus[]>([]);
    const [estatisticasTimeRow, setEstatisticasTimeRow] = useState<IDadosTimeVersus[]>([]);
    const [estatisticasTime, setEstatisticasTime] = useState<IDadosTimeVersus>();
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [qtdRodadasFiltro, setQtdRodadasFiltro] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [lstFraqnuias, setLstFranquias] = useState<ILstDrop[]>([]);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [franquiaFiltro, setFranquiaFiltro] = useState(0);

    const [ast, setAst] = useState(0);
    const [blk, setBlk] = useState(0);
    const [dreb, setDreb] = useState(0);
    const [fga, setFga] = useState(0);
    const [fgm, setFgm] = useState(0);
    const [fgmp, setFgmp] = useState(0);
    const [fta, setFta] = useState(0);
    const [ftm, setFtm] = useState(0);
    const [ftmp, setFtmp] = useState(0);
    const [min, setMin] = useState(0);
    const [mplu, setMplu] = useState(0);
    const [oreb, setOreb] = useState(0);
    const [pf, setPf] = useState(0);
    const [pts, setPts] = useState(0);
    const [reb, setReb] = useState(0);
    const [stl, setStl] = useState(0);
    const [threepa, setThreepa] = useState(0);
    const [threepm, setThreepm] = useState(0);
    const [threepmp, setThreepmp] = useState(0);
    const [to, setTo] = useState(0);
    const [fge, setFge] = useState(0);
    const [fte, setFte] = useState(0);
    const [threepe, setThreepe] = useState(0);
    const [stocks, setStocks] = useState(0);


    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    // const [showModalEvent, setShowModalEvent] = useState(false);
    // const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
    //     acao: false,
    //     label: "",
    //     tipo: "info",
    //     mensagem: "",
    //     display: "none",
    //     titulo: "Atenção"
    // });

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""
    });

    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });

                FranquiaService.getByIdLiga(Number(codigoLiga))
                    .then((result) => {
                        const franquias = result.dado;
                        let lstFranquiasAux = franquias.map((f, i) => ({ codigo: f.codigo, label: f.nome }));
                        setLstFranquias(lstFranquiasAux);

                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                        setTemporadaFiltro(liga.codigo_Temporada);
                        setIsLoading(false);
                        setRemoveLoading(true);
                        //carregarDadosTimes(liga.codigo_Temporada, qtdRodadasFiltro);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });
            })
        }
    }, []);

    const carregarDadosTimes = () => {
        //LimparListas();

        setIsLoading(true);
        setRemoveLoading(false);

        if (temporadaFiltro === 0) {
            setIsLoading(false);
            setShowModalMensagem(true);
            setRemoveLoading(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a temporada!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        if (qtdRodadasFiltro === 0) {
            setIsLoading(false);
            setShowModalMensagem(true);
            setRemoveLoading(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a quantidade de rodadas!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        if (franquiaFiltro === 0) {
            setIsLoading(false);
            setShowModalMensagem(true);
            setRemoveLoading(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar uma franquia!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        EstatisticasService.getTimeVersus(Number(codigoLiga), franquiaFiltro, temporadaFiltro, qtdRodadasFiltro)
            .then((result) => {
                const lstDados = result.dado;

                if (lstDados === null || lstDados === undefined) {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Não foram encontrados informações para o(s) filtro(s) informado(s)!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setIsLoading(false);
                setRemoveLoading(true);
                setEstatisticasRows(lstDados.franquias_Liga);
                setEstatisticasTime(lstDados.franquia);

                let dadosTime: IDadosTimeVersus[] = [];
                dadosTime.push(lstDados.franquia);
                setEstatisticasTimeRow(dadosTime);

                const newRow = {
                    codigo: 100,
                    codigo_NBA: 100,
                    nome: "POSIÇÃO",
                    ast: lstDados.classificacao_Franquia.ast !== null && lstDados.classificacao_Franquia.ast !== undefined ? parseFloat(lstDados.classificacao_Franquia.ast.toString()) : 0,
                    blk: lstDados.classificacao_Franquia.blk !== null && lstDados.classificacao_Franquia.blk !== undefined ? parseFloat(lstDados.classificacao_Franquia.blk.toString()) : 0,
                    dreb: lstDados.classificacao_Franquia.dreb !== null && lstDados.classificacao_Franquia.dreb !== undefined ? parseFloat(lstDados.classificacao_Franquia.dreb.toString()) : 0,
                    fga: lstDados.classificacao_Franquia.fga !== null && lstDados.classificacao_Franquia.fga !== undefined ? parseFloat(lstDados.classificacao_Franquia.fga.toString()) : 0,
                    fgm: lstDados.classificacao_Franquia.fgm !== null && lstDados.classificacao_Franquia.fgm !== undefined ? parseFloat(lstDados.classificacao_Franquia.fgm.toString()) : 0,
                    fgmp: lstDados.classificacao_Franquia.fgmp !== null && lstDados.classificacao_Franquia.fgmp !== undefined ? parseFloat(lstDados.classificacao_Franquia.fgmp.toString()) : 0,
                    fta: lstDados.classificacao_Franquia.fta !== null && lstDados.classificacao_Franquia.fta !== undefined ? parseFloat(lstDados.classificacao_Franquia.fta.toString()) : 0,
                    ftm: lstDados.classificacao_Franquia.ftm !== null && lstDados.classificacao_Franquia.ftm !== undefined ? parseFloat(lstDados.classificacao_Franquia.ftm.toString()) : 0,
                    ftmp: lstDados.classificacao_Franquia.ftmp !== null && lstDados.classificacao_Franquia.ftmp !== undefined ? parseFloat(lstDados.classificacao_Franquia.ftmp.toString()) : 0,
                    //min:  lstDados.classificacao_Franquia.min !== null &&  lstDados.classificacao_Franquia.min !== undefined ? parseFloat(lstDados.classificacao_Franquia.min.toString()) : 0,
                    mplu: lstDados.classificacao_Franquia.mplu !== null && lstDados.classificacao_Franquia.mplu !== undefined ? parseFloat(lstDados.classificacao_Franquia.mplu.toString()) : 0,
                    oreb: lstDados.classificacao_Franquia.oreb !== null && lstDados.classificacao_Franquia.oreb !== undefined ? parseFloat(lstDados.classificacao_Franquia.oreb.toString()) : 0,
                    pf: lstDados.classificacao_Franquia.pf !== null && lstDados.classificacao_Franquia.pf !== undefined ? parseFloat(lstDados.classificacao_Franquia.pf.toString()) : 0,
                    pts: lstDados.classificacao_Franquia.pts !== null && lstDados.classificacao_Franquia.pts !== undefined ? parseFloat(lstDados.classificacao_Franquia.pts.toString()) : 0,
                    reb: lstDados.classificacao_Franquia.reb !== null && lstDados.classificacao_Franquia.reb !== undefined ? parseFloat(lstDados.classificacao_Franquia.reb.toString()) : 0,
                    stl: lstDados.classificacao_Franquia.stl !== null && lstDados.classificacao_Franquia.stl !== undefined ? parseFloat(lstDados.classificacao_Franquia.stl.toString()) : 0,
                    threepa: lstDados.classificacao_Franquia.threepa !== null && lstDados.classificacao_Franquia.threepa !== undefined ? parseFloat(lstDados.classificacao_Franquia.threepa.toString()) : 0,
                    threepm: lstDados.classificacao_Franquia.threepm !== null && lstDados.classificacao_Franquia.threepm !== undefined ? parseFloat(lstDados.classificacao_Franquia.threepm.toString()) : 0,
                    threepmp: lstDados.classificacao_Franquia.threepmp !== null && lstDados.classificacao_Franquia.threepmp !== undefined ? parseFloat(lstDados.classificacao_Franquia.threepmp.toString()) : 0,
                    to: lstDados.classificacao_Franquia.to !== null && lstDados.classificacao_Franquia.to !== undefined ? parseFloat(lstDados.classificacao_Franquia.to.toString()) : 0,
                    fge: lstDados.classificacao_Franquia.fgm !== null && lstDados.classificacao_Franquia.fge !== undefined ? parseFloat(lstDados.classificacao_Franquia.fge.toString()) : 0,
                    fte: lstDados.classificacao_Franquia.fgm !== null && lstDados.classificacao_Franquia.fte !== undefined ? parseFloat(lstDados.classificacao_Franquia.fte.toString()) : 0,
                    threepe: lstDados.classificacao_Franquia.fgm !== null && lstDados.classificacao_Franquia.threepe !== undefined ? parseFloat(lstDados.classificacao_Franquia.threepe.toString()) : 0,
                    stocks: lstDados.classificacao_Franquia.fgm !== null && lstDados.classificacao_Franquia.stocks !== undefined ? parseFloat(lstDados.classificacao_Franquia.stocks.toString()) : 0,
                }
                setEstatisticasTimeRow((itens) => [...itens, newRow]);

                // estatisticasTimeClassificacaoRow.push(lstDados.classificacao_Franquia);
                //estatisticasTimeRow.push(lstDados.classificacao_Franquia);

                setAst(lstDados.franquia.ast !== null && lstDados.franquia.ast !== undefined ? lstDados.franquia.ast : 0)
                setBlk(lstDados.franquia.blk !== null && lstDados.franquia.blk !== undefined ? lstDados.franquia.blk : 0)
                setDreb(lstDados.franquia.dreb !== null && lstDados.franquia.dreb !== undefined ? lstDados.franquia.dreb : 0)
                setFga(lstDados.franquia.fga !== null && lstDados.franquia.fga !== undefined ? lstDados.franquia.fga : 0)
                setFgm(lstDados.franquia.fgm !== null && lstDados.franquia.fgm !== undefined ? lstDados.franquia.fgm : 0)
                setFgmp(lstDados.franquia.fgmp !== null && lstDados.franquia.fgmp !== undefined ? lstDados.franquia.fgmp : 0)
                setFta(lstDados.franquia.fta !== null && lstDados.franquia.fta !== undefined ? lstDados.franquia.fta : 0)
                setFtm(lstDados.franquia.ftm !== null && lstDados.franquia.ftm !== undefined ? lstDados.franquia.ftm : 0)
                setFtmp(lstDados.franquia.ftmp !== null && lstDados.franquia.ftmp !== undefined ? lstDados.franquia.ftmp : 0)
                setMin(lstDados.franquia.min !== null && lstDados.franquia.min !== undefined ? lstDados.franquia.min : 0)
                setMplu(lstDados.franquia.mplu !== null && lstDados.franquia.mplu !== undefined ? lstDados.franquia.mplu : 0)
                setOreb(lstDados.franquia.oreb !== null && lstDados.franquia.oreb !== undefined ? lstDados.franquia.oreb : 0)
                setPf(lstDados.franquia.pf !== null && lstDados.franquia.pf !== undefined ? lstDados.franquia.pf : 0)
                setPts(lstDados.franquia.pts !== null && lstDados.franquia.pts !== undefined ? lstDados.franquia.pts : 0)
                setReb(lstDados.franquia.reb !== null && lstDados.franquia.reb !== undefined ? lstDados.franquia.reb : 0)
                setStl(lstDados.franquia.stl !== null && lstDados.franquia.stl !== undefined ? lstDados.franquia.stl : 0)
                setThreepa(lstDados.franquia.threepa !== null && lstDados.franquia.threepa !== undefined ? lstDados.franquia.threepa : 0)
                setThreepm(lstDados.franquia.threepm !== null && lstDados.franquia.threepm !== undefined ? lstDados.franquia.threepm : 0)
                setThreepmp(lstDados.franquia.threepmp !== null && lstDados.franquia.threepmp !== undefined ? lstDados.franquia.threepmp : 0)
                setTo(lstDados.franquia.to !== null && lstDados.franquia.to !== undefined ? lstDados.franquia.to : 0);
                setFge(lstDados.franquia.fge !== null && lstDados.franquia.fge !== undefined ? lstDados.franquia.fge : 0)
                setFte(lstDados.franquia.fte !== null && lstDados.franquia.fte !== undefined ? lstDados.franquia.fte : 0)
                setThreepe(lstDados.franquia.threepe !== null && lstDados.franquia.threepe !== undefined ? lstDados.franquia.threepe : 0)
                setStocks(lstDados.franquia.stocks !== null && lstDados.franquia.stocks !== undefined ? lstDados.franquia.stocks : 0)
            })
            .catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {

                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                //setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    // const toggleModalEvent = () => {
    //     setShowModalEvent(modalVisivel => !modalVisivel);
    //     if (redirecionar !== "") {
    //         redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    //     }
    // }

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        setEstatisticasRows([]);
        setEstatisticasTimeRow([]);
        if (Number(e.target.value) > 0) {
            //carregarDadosTimes(e.target.value, qtdRodadasFiltro);
        }
    }

    const handleQuantidadeRodadas = async (e: { target: { name: string; value: any; }; }) => {
        setQtdRodadasFiltro(e.target.value);
        setEstatisticasRows([]);
        setTemporadaFiltro(temporadaFiltro);
        setFranquiaFiltro(franquiaFiltro);
        setEstatisticasTimeRow([]);
        if (Number(e.target.value) > 0) {
            //carregarDadosTimes(e.target.value, qtdRodadasFiltro);
        }

    }

    const handleSelectedFranquia = async (e: { target: { name: string; value: any; }; }) => {

        setFranquiaFiltro(Number(e.target.value));
        setEstatisticasRows([]);
        setTemporadaFiltro(temporadaFiltro);
        setQtdRodadasFiltro(qtdRodadasFiltro);
        setEstatisticasTimeRow([]);
        if (Number(e.target.value) > 0) {
            //carregarDadosTimes(e.target.value, qtdRodadasFiltro);
        }
    }


    const columnsGeralTime: GridColDef[] = [
        {
            field: 'codigo',
            headerName: '',
            flex: 1,
            minWidth: 58,
            maxWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',


        }, {
            field: 'caminho_Logo',
            headerName: 'LOGO',
            editable: false,
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 65,
            maxWidth: 65,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value !== null && params.row.nome !== "POSIÇÃO" ? <img src={params.value} width={ UtilidadeService.isMobile() ? 30 : 45} height={ UtilidadeService.isMobile() ? 35 :50} /> : null,
        },
        {
            field: 'nome',
            headerName: 'FRANQUIA',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    nomeRight: params.row.nome === 'POSIÇÃO',
                    nomeLeft: params.row.nome !== 'POSIÇÃO',
                });
            },
        },

        {
            field: 'quantidade_Jogos',
            headerName: 'QTD',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            editable: false,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'min',
            headerName: 'MIN',
            editable: false,
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : "0"

        },
        {
            field: 'fgm',
            headerName: 'FGM',
            editable: false,
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")

        },
        {
            field: 'threepm',
            headerName: '3PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")

        },
        {
            field: 'pts',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")


        },
        {
            field: 'reb',
            headerName: 'REB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")
        },
        {
            field: 'oreb',
            headerName: 'OREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")
        },
        {
            field: 'dreb',
            headerName: 'DREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")
        },
        {
            field: 'ast',
            headerName: 'AST',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")
        },
        {
            field: 'stl',
            headerName: 'STL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")
        },
        {
            field: 'blk',
            headerName: 'BLK',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")
        },
        {
            field: 'to',
            headerName: 'TO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ","),

        },
        {
            field: 'pf',
            headerName: 'PF',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")

        },
        {
            field: 'mplu',
            headerName: 'MPLU',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")

        },
        {
            field: 'fgmp',
            headerName: 'FGM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")

        },
        {
            field: 'ftmp',
            headerName: 'FTM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")

        },
        {
            field: 'threepmp',
            headerName: '3P%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.row.nome === "POSIÇÃO" ? `${params.value}º` : params.value.toFixed(2).replace(".", ",")

        },
        {
            field: 'placar_Mandante',
            headerName: '-',
            editable: false,
            headerClassName: 'super-app--add',
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            headerAlign: 'center',
            renderCell: (params) => params.value == null ? null : null
        }
    ];

    const columnsGeral: GridColDef[] = [
        {
            field: 'codigo',
            headerName: '',
            flex: 1,
            minWidth: 58,
            maxWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',


        }, {
            field: 'caminho_Logo',
            headerName: 'LOGO',
            editable: false,
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 65,
            maxWidth: 65,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value !== null ? <img src={params.value} width={ UtilidadeService.isMobile() ? 30 : 45} height={ UtilidadeService.isMobile() ? 35 :50} /> : null,
        },
        {
            field: 'nome',
            headerName: 'FRANQUIA',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 150,
            headerClassName: 'super-app-theme--header'
        },

        {
            field: 'quantidade_Jogos',
            headerName: 'QTD',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            editable: false,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'min',
            headerName: 'MIN',
            editable: false,
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'fgm',
            headerName: 'FGM',
            editable: false,
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(fgm.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(fgm.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'threepm',
            headerName: '3PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(threepm.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(threepm.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"


        },
        {
            field: 'pts',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(pts.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(pts.toString()) > parseFloat(params.value.toString()),
                    //estatisticasTimeRow !== null && estatisticasTimeRow.find(f=> f) !== null ? estatisticasTimeRow.find(f=> f)?.pts : 0 >= parseFloat(params.value.toString()) ,
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"


        },
        {
            field: 'reb',
            headerName: 'REB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(reb.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(reb.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'oreb',
            headerName: 'OREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(oreb.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(oreb.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'dreb',
            headerName: 'DREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(dreb.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(dreb.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'ast',
            headerName: 'AST',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(ast.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(ast.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'stl',
            headerName: 'STL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(stl.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(stl.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'blk',
            headerName: 'BLK',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(blk.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(blk.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'to',
            headerName: 'TO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(to.toString()) > parseFloat(params.value.toString()),
                    positive: parseFloat(to.toString()) < parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'pf',
            headerName: 'PF',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(pf.toString()) > parseFloat(params.value.toString()),
                    positive: parseFloat(pf.toString()) < parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'mplu',
            headerName: 'MPLU',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(mplu.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(mplu.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'fgmp',
            headerName: 'FGM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(fgmp.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(fgmp.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'ftmp',
            headerName: 'FTM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(ftmp.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(ftmp.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'threepmp',
            headerName: '3P%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(threepmp.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(threepmp.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'placar_Franquia_Adversaria',
            headerName: 'PLACAR',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 78,
            maxWidth: 78,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: params.row.placar_Franquia_Selecionada < params.row.placar_Franquia_Adversaria,
                    positive: params.row.placar_Franquia_Selecionada > params.row.placar_Franquia_Adversaria,
                });
            },
            renderCell: (params) => params.value !== null ? `${params.row.placar_Franquia_Selecionada} x ${params.row.placar_Franquia_Adversaria} ` : "0"
        },
        {
            field: 'fte',
            headerName: 'FTE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(fte.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(fte.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'fge',
            headerName: 'FGE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(fge.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(fge.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'threepe',
            headerName: 'TREEPE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(threepe.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(threepe.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'stocks',
            headerName: 'STOCKS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable:  UtilidadeService.isMobile() ?false : true ,
            minWidth: 70,
            maxWidth: 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(stocks.toString()) < parseFloat(params.value.toString()),
                    positive: parseFloat(stocks.toString()) > parseFloat(params.value.toString()),
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : 0
        },
    ];

    return (
        <LayoutBaseDePagina
            titulo={`Franquia X - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {/* {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />} */}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Franquia Versus </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={handleSelectedTemporada}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3, md: 3 }} display="flex" justifyContent="center">
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Quantidade Rodadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={qtdRodadasFiltro}
                                            label="Quantidade Rodadas"
                                            onChange={handleQuantidadeRodadas}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstQtdRodadasFiltro.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Franquia 1</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={franquiaFiltro}
                                            label="Franquia"
                                            onChange={handleSelectedFranquia}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstFraqnuias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        disableElevation
                                        onClick={carregarDadosTimes}
                                        startIcon={<Icon>change_circle</Icon>}
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {estatisticasTimeRow.length > 0 && (
                                    <Box sx={{
                                        height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                        '& .super-app-theme--header': {
                                            backgroundColor: theme.palette.common.black,
                                            color: theme.palette.common.white,
                                        },
                                        '& .super-app.negative': {
                                            color: 'red',
                                            fontWeight: 'bold'
                                        },
                                        '& .super-app.positive': {
                                            color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                            fontWeight: '600',
                                        },
                                        '& .super-app-theme--cell': {
                                            color: '#00e676',
                                            fontWeight: '600',
                                        },
                                        '& .super-app.nomeRight ': {
                                            justifyContent: "right",
                                        },
                                        '& .super-app.nomeLeft': {
                                            justifyContent: "left",
                                        },
                                        '& .super-app--add': {
                                            backgroundColor: "black",
                                            color: "white",
                                        },

                                    }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.codigo}
                                            rows={estatisticasTimeRow}
                                            columns={columnsGeralTime}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 16,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                codigo: false,
                                                ast: estatisticasTimeRow.filter(f => f.ast === null).length === 0,
                                                blk: estatisticasTimeRow.filter(f => (f.blk === null)).length === 0,
                                                dreb: estatisticasTimeRow.filter(f => (f.dreb === null)).length === 0,
                                                fga: estatisticasTimeRow.filter(f => (f.fga === null)).length === 0,
                                                fgm: estatisticasTimeRow.filter(f => f.fgm === null).length === 0,
                                                fgmp: estatisticasTimeRow.filter(f => (f.fgmp === null)).length === 0,
                                                fta: estatisticasTimeRow.filter(f => (f.fta === null)).length === 0,
                                                ftm: estatisticasTimeRow.filter(f => (f.ftm === null)).length === 0,
                                                ftmp: estatisticasTimeRow.filter(f => (f.ftmp === null)).length === 0,
                                                min: estatisticasTimeRow.filter(f => (f.min === null)).length === 0,
                                                mplu: estatisticasTimeRow.filter(f => (f.mplu === null)).length === 0,
                                                oreb: estatisticasTimeRow.filter(f => (f.oreb === null)).length === 0,
                                                pf: estatisticasTimeRow.filter(f => (f.pf === null)).length === 0,
                                                pts: estatisticasTimeRow.filter(f => (f.pts === null)).length === 0,
                                                reb: estatisticasTimeRow.filter(f => (f.reb === null)).length === 0,
                                                stl: estatisticasTimeRow.filter(f => (f.stl === null)).length === 0,
                                                threepa: estatisticasTimeRow.filter(f => (f.threepa === null)).length === 0,
                                                threepm: estatisticasTimeRow.filter(f => (f.threepm === null)).length === 0,
                                                threepmp: estatisticasTimeRow.filter(f => (f.threepmp === null)).length === 0,
                                                to: estatisticasTimeRow.filter(f => (f.to === null)).length === 0,

                                                fge: estatisticasTimeRow.filter(f => (f.fge === null)).length === 0,
                                                fte: estatisticasTimeRow.filter(f => (f.fte === null)).length === 0,
                                                threepe: estatisticasTimeRow.filter(f => (f.threepe === null)).length === 0,
                                                stocks: estatisticasTimeRow.filter(f => (f.stocks === null)).length === 0,

                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            pageSizeOptions={[16, 25, 50, 100]}
                                            disableRowSelectionOnClick
                                            disableColumnFilter
                                            disableColumnMenu
                                            hideFooter
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 11 : 16,
                                            }}
                                        />
                                    </Box>
                                )}

                                <Grid size={{ xs: 12, sm: 12 }} height={500} style={{ width: "101.3%", maxWidth: "102.3%", overflowX: "auto" }} paddingTop={1}>
                                    {estatisticasRows.length > 0 && (
                                        <Box sx={{
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "400px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                getRowId={(r) => r.codigo}
                                                rows={estatisticasRows}
                                                columns={columnsGeral}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 25,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    codigo: false,
                                                    ast: estatisticasRows.filter(f => f.ast === null).length === 0,
                                                    blk: estatisticasRows.filter(f => (f.blk === null)).length === 0,
                                                    dreb: estatisticasRows.filter(f => (f.dreb === null)).length === 0,
                                                    fga: estatisticasRows.filter(f => (f.fga === null)).length === 0,
                                                    fgm: estatisticasRows.filter(f => f.fgm === null).length === 0,
                                                    fgmp: estatisticasRows.filter(f => (f.fgmp === null)).length === 0,
                                                    fta: estatisticasRows.filter(f => (f.fta === null)).length === 0,
                                                    ftm: estatisticasRows.filter(f => (f.ftm === null)).length === 0,
                                                    ftmp: estatisticasRows.filter(f => (f.ftmp === null)).length === 0,
                                                    min: estatisticasRows.filter(f => (f.min === null)).length === 0,
                                                    mplu: estatisticasRows.filter(f => (f.mplu === null)).length === 0,
                                                    oreb: estatisticasRows.filter(f => (f.oreb === null)).length === 0,
                                                    pf: estatisticasRows.filter(f => (f.pf === null)).length === 0,
                                                    pts: estatisticasRows.filter(f => (f.pts === null)).length === 0,
                                                    reb: estatisticasRows.filter(f => (f.reb === null)).length === 0,
                                                    stl: estatisticasRows.filter(f => (f.stl === null)).length === 0,
                                                    threepa: estatisticasRows.filter(f => (f.threepa === null)).length === 0,
                                                    threepm: estatisticasRows.filter(f => (f.threepm === null)).length === 0,
                                                    threepmp: estatisticasRows.filter(f => (f.threepmp === null)).length === 0,
                                                    to: estatisticasRows.filter(f => (f.to === null)).length === 0,
                                                    fge: estatisticasTimeRow.filter(f => (f.fge === null)).length === 0,
                                                    fte: estatisticasTimeRow.filter(f => (f.fte === null)).length === 0,
                                                    threepe: estatisticasTimeRow.filter(f => (f.threepe === null)).length === 0,
                                                    stocks: estatisticasTimeRow.filter(f => (f.stocks === null)).length === 0,
                                                }}
                                                disableDensitySelector
                                                disableVirtualization
                                                pageSizeOptions={[25, 50, 100]}
                                                disableRowSelectionOnClick
                                                disableColumnFilter
                                                disableColumnMenu
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 11 : 16,
                                                }}
                                            />
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}

